ratingSnippet("ruk_rating_snippet", {
  store: ratingSnippetJson.store,
  mode: "default",
  color: "#678041",
  linebreak: !1,
  text: "",
  singularText: "",
  lang: ratingSnippetJson.lang,
  usePolaris: !1,
  showEmptyStars: !1,
}),
  new carouselInlineWidget("reviewsio-carousel-widget", {
    store: ratingSnippetJson.store,
    sku: "",
    lang: ratingSnippetJson.lang,
    carousel_type: "default",
    styles_carousel: "CarouselWidget--sideHeader--withcards",
    options: {
      general: {
        review_type: "company, product",
        min_reviews: "1",
        max_reviews: "20",
        address_format: "CITY, COUNTRY",
        enable_auto_scroll: 1e4,
      },
      header: { enable_overall_stars: !0, rating_decimal_places: 2 },
      reviews: {
        enable_customer_name: !0,
        enable_customer_location: !0,
        enable_verified_badge: !0,
        enable_subscriber_badge: !0,
        enable_recommends_badge: !0,
        enable_photos: !0,
        enable_videos: !0,
        enable_review_date: !0,
        disable_same_customer: !0,
        min_review_percent: 4,
        third_party_source: !0,
        hide_empty_reviews: !0,
        enable_product_name: !0,
        tags: "",
        branch: "",
        enable_branch_name: !1,
      },
      popups: {
        enable_review_popups: !0,
        enable_helpful_buttons: !0,
        enable_helpful_count: !0,
        enable_share_buttons: !0,
      },
    },
    translations: { verified_customer: "" },
    styles: {
      "--base-font-size": "16px",
      "--base-maxwidth": "100%",
      "--reviewsio-logo-style": "var(--logo-normal)",
      "--common-star-color": "#748B46",
      "--common-star-disabled-color": " rgba(0,0,0,0.25)",
      "--medium-star-size": "22px",
      "--small-star-size": "19px",
      "--x-small-star-size": "16px",
      "--x-small-star-display": "inline-flex",
      "--header-order": "1",
      "--header-width": "280px",
      "--header-bg-start-color": "#F5F5F5",
      "--header-bg-end-color": "#F5F5F5",
      "--header-gradient-direction": "135deg",
      "--header-padding": "1.5em",
      "--header-border-width": "0px",
      "--header-border-color": "rgba(0,0,0,0.1)",
      "--header-border-radius": "0px",
      "--header-shadow-size": "10px",
      "--header-shadow-color": "rgba(0, 0, 0, 0.05)",
      "--header-star-color": "#748b46",
      "--header-disabled-star-color": "inherit",
      "--header-heading-text-color": "#000000",
      "--header-heading-font-size": "inherit",
      "--header-heading-font-weight": "inherit",
      "--header-heading-line-height": "inherit",
      "--header-heading-text-transform": "inherit",
      "--header-subheading-text-color": "#000000",
      "--header-subheading-font-size": "inherit",
      "--header-subheading-font-weight": "300",
      "--header-subheading-line-height": "inherit",
      "--header-subheading-text-transform": "inherit",
      "--item-maximum-columns": "5",
      "--item-background-start-color": "#ffffff",
      "--item-background-end-color": "#ffffff",
      "--item-gradient-direction": "135deg",
      "--item-padding": "1.5em",
      "--item-border-width": "0px",
      "--item-border-color": "rgba(0,0,0,0.1)",
      "--item-border-radius": "0px",
      "--item-shadow-size": "10px",
      "--item-shadow-color": "rgba(0,0,0,0.05)",
      "--heading-text-color": " #0E1311",
      "--heading-text-font-weight": " 600",
      "--heading-text-font-family": " inherit",
      "--heading-text-line-height": " 1.4",
      "--heading-text-letter-spacing": "0",
      "--heading-text-transform": "none",
      "--body-text-color": " #0E1311",
      "--body-text-font-weight": "400",
      "--body-text-font-family": " inherit",
      "--body-text-line-height": " 1.4",
      "--body-text-letter-spacing": "0",
      "--body-text-transform": "none",
      "--scroll-button-icon-color": "#0E1311",
      "--scroll-button-icon-size": "24px",
      "--scroll-button-bg-color": "transparent",
      "--scroll-button-border-width": "0px",
      "--scroll-button-border-color": "rgba(0,0,0,0.1)",
      "--scroll-button-border-radius": "60px",
      "--scroll-button-shadow-size": "0px",
      "--scroll-button-shadow-color": "rgba(0,0,0,0.1)",
      "--scroll-button-horizontal-position": "3px",
      "--scroll-button-vertical-position": "0px",
      "--badge-icon-color": "#0E1311",
      "--badge-icon-font-size": "15px",
      "--badge-text-color": "#0E1311",
      "--badge-text-font-size": "inherit",
      "--badge-text-letter-spacing": "inherit",
      "--badge-text-transform": "inherit",
      "--author-font-size": "inherit",
      "--author-font-weight": "inherit",
      "--author-text-transform": "inherit",
      "--photo-video-thumbnail-size": "60px",
      "--photo-video-thumbnail-border-radius": "0px",
      "--popup-backdrop-color": "rgba(0,0,0,0.75)",
      "--popup-color": "#ffffff",
      "--popup-star-color": "inherit",
      "--popup-disabled-star-color": "inherit",
      "--popup-heading-text-color": "inherit",
      "--popup-body-text-color": "inherit",
      "--popup-badge-icon-color": "inherit",
      "--popup-badge-icon-font-size": "19px",
      "--popup-badge-text-color": "inherit",
      "--popup-badge-text-font-size": "14px",
      "--popup-border-width": "0px",
      "--popup-border-color": "rgba(0,0,0,0.1)",
      "--popup-border-radius": "0px",
      "--popup-shadow-size": "0px",
      "--popup-shadow-color": "rgba(0,0,0,0.1)",
      "--popup-icon-color": "#0E1311",
      "--tooltip-bg-color": "#0E1311",
      "--tooltip-text-color": "#ffffff",
    },
  });
